import { Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";

import ImageCaption from "./ImageCaption.vue";

export default Node.create({
  name: "imagecaption",

  group: "block",
  content: "inline*",

  defining: true,

  addCommands() {
    return {
      setImageCaption: attributes => ({ commands }) => {
        return commands.setNode(this.name, attributes);
      },
      toggleImageCaption: attributes => ({ commands }) => {
        return commands.toggleNode(this.name, "paragraph", attributes);
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "image-caption"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["image-caption", HTMLAttributes, 0];
  },

  addNodeView() {
    return VueNodeViewRenderer(ImageCaption);
  }
});
